export const environment = {
  production: false,
  // Ops QAS consume exclusivamente el backend QAS.
  adminApiUrl: 'https://api.qas.khipure.com/api/admin/',
  apiUrl: 'https://api.qas.khipure.com/api/'
};
